;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';
	const View = APP.module('View');
	View.HelpPrizes = Marionette.ItemView.extend({
		template:    JST.helpPrizes,
		tagName:     'div',
		initialize:  function() {
			this.model.set({
				title:   '',
				content: '',
				permit:  ''
			});
			this.model.appendScript(this);

		},
		showContent: function() {
			let property = this.model.property,
				content  = EXPORTS.GLOBAL_DATA[property]['items'][0] ? EXPORTS.GLOBAL_DATA[property]['items'][0].text : 'Lorem ipsum dolor sit amet...';

			this.model.set({
				title:   EXPORTS.GLOBAL_DATA[property]['items'][0] ? EXPORTS.GLOBAL_DATA[property]['items'][0].title : 'Prizes',
				content: content
			});

			this.render();
		}
	});

}(window, APP, Backbone, Marionette, $, _));